import { render } from "./lidaPage.vue?vue&type=template&id=71952656"
import script from "./lidaPage.vue?vue&type=script&lang=js"
export * from "./lidaPage.vue?vue&type=script&lang=js"

import "./lidaPage.vue?vue&type=style&index=0&id=71952656&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__